<template>
  <div>
  <b-row>
    <b-col cols="12">
  <div class="d-flex justify-content-end mb-2">
    <b-button variant="success" @click="exportToCSV">
      <feather-icon icon="DownloadIcon" class="mr-50" />
      Export to CSV
    </b-button>
    <b-button variant="primary" to="/product/add" class="ml-2">
      <feather-icon icon="PlusIcon" class="mr-50" />
      Add Product
    </b-button>
  </div>
</b-col>
</b-row>

<b-row>
    <b-col cols="12" md="6" class="my-1">
      <b-form-group label="Select Columns:" class="mb-0">
        <b-form-checkbox-group 
          v-model="selectedColumns" 
          :options="columnOptions"
        ></b-form-checkbox-group>
      </b-form-group>
    </b-col>
  </b-row>

    <b-col  cols="12" md="2" sm="2" class="my-1">
      <b-form-group class="mb-0">
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"  />
      </b-form-group>
    </b-col>

    <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
      <b-button variant="outline-danger"  @click="clearColumnFilters">
        Clear Filters
      </b-button>
    </b-col> 

    <b-row>

    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredData"
        :fields="dynamicFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
        @filtered="onFiltered">
        <!-- Filter input for Name -->
        <template #head(name)>
          <div class="d-flex flex-column">
            <span>Name</span>
            <b-form-input v-model="filters.name" placeholder="Filter by Name" size="sm" @input="filterTable" />
          </div>
        </template>

        <!-- Filter input for Code -->
        <template #head(barcode)>
          <div class="d-flex flex-column">
            <span>Barcode</span>
            <b-form-input v-model="filters.barcode" placeholder="Filter by Code" size="sm" @input="filterTable" />
          </div>
        </template>

        <!-- Filter input for Supplier -->
        <template #head(supplierName)>
          <div class="d-flex flex-column">
            <span>Supplier</span>
            <b-form-input v-model="filters.supplier" placeholder="Filter by Supplier" size="sm" @input="filterTable" />
          </div>
        </template>

        <!-- Filter input for Category -->
        <template #head(categoryName)>
          <div class="d-flex flex-column">
            <span>Category</span>
            <b-form-input v-model="filters.category" placeholder="Filter by Category" size="sm" @input="filterTable" />
          </div>
        </template>

        <!-- Filter input for Sub Category -->
        <template #head(subCategoryName)>
          <div class="d-flex flex-column">
            <span>Sub Category</span>
            <b-form-input v-model="filters.subcategory" placeholder="Filter by Sub Category" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <template #cell(inHouse)="data">
          <span>{{ data.item.inHouseManufactured ? "Yes" : "No" }}</span>
        </template>
        <template #head(inHouse)>
          <div class="d-flex flex-column">
            <span>In House?</span>
            <b-form-select v-model="filters.house" :options="inhouseOptions" size="sm" @change="filterTable" />
          </div>
        </template>


        <!-- Dropdown filter for Type -->
        <template #head(type)>
          <div class="d-flex flex-column">
            <span>Type</span>
            <b-form-select v-model="filters.type" :options="typeOptions" size="sm" @change="filterTable" />
          </div>
        </template>

        <template #cell(balance)="data">
          <b-button :to="getProductStock(data.item.id)" v-b-tooltip.hover.focus.v-secondary
            title="View details of Stock">
            <div class="d-flex flex-shrink">
              <feather-icon icon="BoxIcon" class="mr-50" />
              <span>{{ data.item.totalBalance }}</span>
            </div>
          </b-button>
        </template>
        <template #cell(supplier)="data">
          {{ data.item.supplierName }}
</template>

<template #cell(type)="data">
  <b-badge v-if="data.item.type === 1" variant="primary">
    Finished Product
  </b-badge>
  <b-badge v-if="data.item.type === 2" variant="info">
    Semi Finished Product
  </b-badge>
  <!-- <b-badge v-if="data.item.type === 3" variant="secondary">
            Raw Material
          </b-badge> -->
</template>
<template #cell(actions)="data">
  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
    <template v-slot:button-content>
      <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
    </template>
    <b-dropdown-item v-b-modal.modal-edit :to="getProductId(data.item.id)">
      <feather-icon icon="EyeIcon" class="mr-50" />
      <span>View</span>
    </b-dropdown-item>
    <b-dropdown-item v-b-modal.modal-edit :to="getProductEdit(data.item.id)">
      <feather-icon icon="Edit2Icon" class="mr-50" />
      <span>Edit</span>
    </b-dropdown-item>
    <!-- <b-dropdown-item @click="removeProduct(data.item.id)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
            </b-dropdown-item> -->
  </b-dropdown>
</template>
</b-table>

<div class="d-flex justify-content-center mb-1">
  <b-spinner variant="success" label="Spinning" block v-if="loading" style="width: 3rem; height: 3rem"></b-spinner>
</div>
</b-col>

<b-col cols="12">
  <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
    class="my-0" />
    
    <b-form-group>
      Showing 
    {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
    to 
    {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
    of 
    {{ totalRows > 0 ? totalRows : 0 }} 
    entries
    </b-form-group>
</b-col>
</b-row>
</div>
</template>

  <script>
  import {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BDropdownItem,
    VBTooltip,
    BFormCheckboxGroup,
  } from "bootstrap-vue";

  import { mapActions, mapGetters } from "vuex";
  import { fnSortingDropdown, customLoader } from "@/libs/customFn";

  export default {
    components: {
      BTable,
      BAvatar,
      BBadge,
      BRow,
      BCol,
      BFormGroup,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BButton,
      BSpinner,
      BDropdown,
      BDropdownItem,
      BFormCheckboxGroup
    },
    directives: {
      "b-tooltip": VBTooltip,
    },
    data() {
      return {
        inHouseManufactured: null,
        productName: [],
        filteredData: [],
        productCode: [],
        selectedName: null,
        selectedCode: null,
        filterBarcode: null,
        productData: [],
        productListing: [],
        perPage: 5,
        pageOptions: [3, 5, 10],
        totalRows: 1,
        currentPage: 1,
        sortBy: "",
        sortDesc: false,
        sortDirection: "asc",
        filter: null,
        filterOn: [],
        categories: [],
        subcategories: [],
        prefsuppliers: [],
        selectedCategory: "",
        selectedSubCategory: "",
        selectedSupplier: "",
        totalBalance: null,
        filterResults: true,
        infoModal: {
          id: "info-modal",
          title: "",
          content: "",
        },
        selectedColumns: ['name', 'barcode', 'balance', 'supplierName', 'categoryName', 'subCategoryName', 'inHouse', 'actions', 'type', 'actions'], // Default selected columns
      columnOptions: [
        
        { value: 'barcode', text: 'Barcode' },
        { value: 'balance', text: 'View Balance' },
        { value: 'supplierName', text: 'Supplier' },
        { value: 'categoryName', text: 'Category' },
        { value: 'subCategoryName', text: 'Sub Category' },
        { value: 'inHouse', text: 'In House' },
        { value: 'type', text: 'Type' },
        
      ],
        fields: [
          { key: "name", label: "Name", sortable: true },
          { key: "barcode", label: "Barcode", sortable: true },
          { key: "balance", label: "View Balance" },
          { key: "supplierName", label: "Supplier", sortable: true },
          { key: "categoryName", label: "Category", sortable: true },
          { key: "subCategoryName", label: "Sub Category", sortable: true },
          { key: "inHouse", label: "In House" },
          { key: "type" },
          { key: "actions" },
        ],
        filters: {
          name: "",
          barcode: "",
          supplier: "",
          house: null,
          category: "",
          subcategory: "",
          type: null, // For dropdown selection
        },
        typeOptions: [
          { value: null, text: "All" },
          { value: 1, text: "Finished Product" },
          { value: 2, text: "Semi Finished Product" },
          // { value: 3, text: "Raw Material" },
        ],
        inhouseOptions: [
          { value: null, text: "All" },
          { value: true, text: "Yes" },
          { value: false, text: "No" },

        ],
        status: [
          {
            1: "Current",
            2: "Professional",
            3: "Rejected",
            4: "Resigned",
            5: "Applied",
          },
          {
            1: "light-primary",
            2: "light-success",
            3: "light-danger",
            4: "light-warning",
            5: "light-info",
          },
        ],
        inHouseManufacturedOptions: [
          { value: null, text: "All" },
          { value: true, text: "Yes" },
          { value: false, text: "No" },
        ],
      };
    },
    computed: {
      filteredSubCategories() {
        return this.subcategories.filter(
          (sub) => sub.parentId === this.selectedCategory
        );
      },
      dynamicFields() {
      return this.fields.filter(field => this.selectedColumns.includes(field.key));
    },
      Product() {
        return this.productList.filter((item) => item.type !== 4);
      },
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter((f) => f.sortable)
          .map((f) => ({ text: f.label, value: f.key }));
      },
      ...mapGetters("productModule", {
        productList: "product",
        loading: "loading",
      }),
      ...mapGetters("itemBalanceModule", {
        itemBalances: "itemBalances",
        balanceLoading: "loading",
      }),
      ...mapGetters("supplierModule", {
        suppliers: "suppliers",
        loading: "loading",
      }),

      ...mapGetters("itemcategoryModule", {
        itemcategories: "itemcategories",
        loading: "loading",
      }),
    },

    methods: {
      clearFilters() {
        this.selectedCategory = "";
        this.selectedSubCategory = "";
        this.selectedSupplier = "";

        this.filteredData = this.productListing;
        this.totalRows = this.filteredData.length;

        this.currentPage = 1;
      },
      getCategory(category) {
        if (category) {
          return category;
        } else {
          return "-";
        }
      },
      getSubCategory(subcategory) {
        if (subcategory) {
          return subcategory;
        } else {
          return "-";
        }
      },
      getSupplierNameById(id) {
        let supplier = this.suppliers.filter((obj) => {
          return obj.id === id;
        });
        if (supplier.length > 0) {
          return supplier[0].name;
        } else {
          return "-";
        }
      },
      populateCategoriesAndSubcategories() {
        this.categories = [{ value: "", text: "All" }].concat(
          this.itemcategories
            .filter((category) => category.parentId === null)
            .slice()
            .sort((a, b) => a.name.localeCompare(b.name))
            // Filter main categories
            .map((category) => ({
              value: category.id,
              text: category.name,
            }))
        );

        this.subcategories = [{ value: "", text: "All" }].concat(
          this.itemcategories
            .filter((category) => category.parentId)
            .slice()
            .sort((a, b) => a.name.localeCompare(b.name)) // Filter subcategories based on parentId
            .map((subcategory) => ({
              value: subcategory.id,
              text: subcategory.name,
            }))
        );

        this.prefsuppliers = [{ value: "", text: "All" }].concat(
          this.suppliers
            .slice()
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((subcategory) => ({
              value: subcategory.id,
              text: subcategory.name,
            }))
        );
      },
      orderFilterChanged() {
        this.filteredData = this.productListing;

        // Filter by selected category
        if (this.selectedCategory) {
          this.filteredData = this.filteredData.filter((obj) => {
            return obj.categoryID === this.selectedCategory;
          });
        }

        // Filter by selected subcategory
        if (this.selectedSubCategory) {
          this.filteredData = this.filteredData.filter((obj) => {
            return obj.subCategoryID === this.selectedSubCategory;
          });
        }

        if (this.selectedSupplier) {
          this.filteredData = this.filteredData.filter((obj) => {
            return obj.supplierId === this.selectedSupplier;
          });
        }

        // Now, update the itemData with the filtered results
        //this.itemData = this.filteredData;
        //console.log(this.itemData)
        // Update the total rows and reset pagination
        this.totalRows = this.filteredData.length;
        this.currentPage = 1;
      },
      getProductData(data) {
        this.productData = data;
      },
      removeProduct(id) {
        this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.removeProductAction(id)
              .then(() => {
                this.$swal({
                  title: "Deleted!",
                  text: "This product has been deleted.",
                  icon: "success",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
              })
              .catch((error) => {
                this.$swal({
                  title: "Error!",
                  text: " Failed! " + error.response.data.message,
                  icon: "error",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  buttonsStyling: false,
                });
              });
          } else if (result.dismiss === "cancel") {
            this.$swal({
              title: "Cancelled",
              text: "Your product is safe :)",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          }
        });
      },
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`;
        this.infoModal.content = JSON.stringify(item, null, 2);
        this.$root.$emit("bv::show::modal", this.infoModal.id, button);
      },
      resetInfoModal() {
        this.infoModal.title = "";
        this.infoModal.content = "";
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      ...mapActions("productModule", [
        "getProductListAction",
        "removeProductAction",
      ]),
      ...mapActions("supplierModule", ["getSupplierListAction"]),
      ...mapActions("itemcategoryModule", ["getItemCategoryListAction"]),
      ...mapActions("itemBalanceModule", ["getItemBalanceListAction"]),
      getProductId(item) {
        return "/product/view/" + item;
      },
      getProductEdit(item) {
        return "/product/edit/" + item;
      },
      getProductStock(item) {
        return "/product/stockTransaction/" + item;
      },
      filterTable() {
        // Apply the filters to the productListing array and store the results in filteredData
        this.filteredData = this.productListing.filter((item) => {
          // Filter by Name
          const matchesName = this.filters.name
            ? item.name && item.name.toLowerCase().includes(this.filters.name.toLowerCase())
            : true;

          // Filter by Code
          const matchesCode = this.filters.barcode
            ? item.barcode && item.barcode.toLowerCase().includes(this.filters.barcode.toLowerCase())
            : true;

          // Filter by Supplier
          const supplierName = this.getSupplierNameById(item.supplierId) || "";
          const matchesSupplier = this.filters.supplier
            ? supplierName.toLowerCase().includes(this.filters.supplier.toLowerCase())
            : true;

          // Filter by Category
          const matchesCategory = this.filters.category
            ? item.categoryName && item.categoryName.toLowerCase().includes(this.filters.category.toLowerCase())
            : true;

          // Filter by Sub Category
          const matchesSubCategory = this.filters.subcategory
            ? item.subCategoryName && item.subCategoryName.toLowerCase().includes(this.filters.subcategory.toLowerCase())
            : true;

          // Filter by Type (dropdown)
          const matchesType = this.filters.type !== null
            ? item.type === this.filters.type
            : true;

          const matchesHouse = this.filters.house !== null
            ? item.inHouseManufactured === this.filters.house
            : true;

          // Combine all filter conditions
          return matchesName && matchesCode && matchesSupplier && matchesCategory && matchesHouse && matchesSubCategory && matchesType;
        });

        // Reset pagination
        this.currentPage = 1;
        this.totalRows = this.filteredData.length;
      },
      clearColumnFilters() {
        // Reset all filter values
        this.filters.name = "";
        this.filters.barcode = "";
        this.filters.supplier = "";
        this.filters.category = "";
        this.filters.subcategory = "";
        this.filters.type = null; // Reset the dropdown filter
        this.filters.house = null;

        // Reset the filtered data
        this.filteredData = [...this.productListing];

        // Reset pagination
        this.currentPage = 1;
        this.totalRows = this.filteredData.length;
      },
      exportToCSV() {
    
    const headers = [
      "Name",
      "Barcode",
      "Total Balance",
      "Supplier",
      "Category",
      "Sub Category",
      "In House",
      "Type",
    ];

    const rows = this.filteredData.map((item) => [
      item.name,
      item.barcode,
      item.totalBalance,
      item.supplierName,
      item.categoryName,
      item.subCategoryName,
      item.inHouseManufactured ? "Yes" : "No",
      item.type === 1
        ? "Finished Product"
        : item.type === 2
        ? "Semi Finished Product"
        : "Unknown",
    ]);

    
    const csvContent =
      headers.join(",") +
      "\n" +
      rows.map((row) => row.map((cell) => `"${cell}"`).join(",")).join("\n");

  
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Products.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
    },
    async mounted() {
      await this.getItemBalanceListAction();
      await this.getSupplierListAction().then(() => {
        this.prefsuppliers = this.suppliers.map((supplier) => ({
          value: supplier.id,
          text: supplier.name,
        }));
      });
      await this.getItemCategoryListAction();
      await this.populateCategoriesAndSubcategories();
      await this.getProductListAction()
        .then(() => {
          this.productListing = this.productList.filter(
            (product) => product.type !== 4
          );



          let addedCodes = {};
          this.productListing = this.productListing.map((product) => {
            // Add productName and productCode to dropdowns
            if (product && product.id !== null && product.name !== null) {
              this.productName.push({
                value: product.id,
                text: `${product.name}`,
              });
            }
            if (product && product.id !== null && product.barcode !== null) {
              if (!addedCodes[product.barcode]) {
                this.productCode.push({
                  value: product.barcode,
                  text: `${product.barcode}`,
                });
                addedCodes[product.barcode] = true;
              }
            }

            const totalBalance = this.itemBalances
              .filter((balance) => balance.itemId === product.id) // Find all entries for the same product
              .reduce(
                (sum, balance) => sum + (balance.physicalInventory ?? 0),
                0
              ); // Sum the physicalInventory values

            // Assign the totalBalance to product.totalBalance
            product.totalBalance = totalBalance;

            return product;
          });

          // Add supplierName, categoryName, subCategoryName for sorting
          this.filteredData = this.productListing.map((product) => {
            return {
              ...product,
              supplierName: this.getSupplierNameById(product.supplierId),
              categoryName: this.getCategory(product.categoryName),
              subCategoryName: this.getSubCategory(product.subCategory),
            };
          });

          // Sort products alphabetically by name
          this.productListing.sort((a, b) => {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            return 0;
          });


          this.filteredData = this.productListing;
          this.totalRows = this.filteredData.length;

        })
        .catch((error) => {
          console.error(error);
        });
    },
  };
</script>